function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

var productResults = {};

function fetchProducts(catId) {
	$.ajax({
		'type': 'get',
		'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
		'cache': false,
		'url': '/api/products/' + catId + '.json',
		'dataType': 'json',
		'timeout': 50000
	}).done(function (response) {
		if (response.data && response.data.length) {
			addtoProductResults(response.data[0].title, response.data[0].entries);
		}
	}).fail(function (error) {
		console.error('API failure');
	});
}

function addtoProductResults(title, products) {
	productResults[title] = products;
	updateProductResults();
}

function updateProductResults() {
	var stockistCat = document.getElementById('categoryFilter').getAttribute('data-stockist-cat');
	var products = Object.keys(productResults).map(function (key) {
		return productResults[key].map(function (product) {
			console.log('product',product);
			return getTile(product, stockistCat);
		}).join('');
	});
	$('#filterResults').html(products.join(''));
	setTimeout(function() {
		$('#filterResults li').removeClass('added');
	}, 200);
}

function truncate(str, num) {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
}

function getTile(product, stockistCat) {
	return '\
	 <li class="productTile added">\
	 <a class="productTileLink" style="background-image:url(' + product.image + ')" href="' + product.url + '" aria-label="' + product.title + '"></a>\
	 <div class="tile-caption">\
		 <h3>' + product.title + '</h3>\
		 <div class="shortDes">' + truncate(product.description || '', 180) + '</div>\
		 <div class="btn-group">\
			 <a href="' + product.url + '" class="blue-btn">view products</a>\
			 <a href="/stockists/results' + (stockistCat ? '/?brand=' + stockistCat : '') + '" class="white-btn">find stockist</a>\
		 </div>\
	 </div>\
	 <div class="mobile-btn">\
		 <a href="/stockists/results" class="white-btn">find a stockist</a>\
	 </div>\
 </li>\
';
}
$(function () {

	if ($('#filterResults').length && $('#filterResults').attr('data-initial-category')) {
		fetchProducts($('#filterResults').attr('data-initial-category'));
	}

	$('#categoryFilter_desktop [data-product-catId]').on('click', function(e) {
		e.preventDefault();
		var catId = e.target.getAttribute('data-product-catId');
		var catSlug = e.target.getAttribute('data-product-catSlug');
		if (productResults.hasOwnProperty(catSlug)) {
			$(e.target.parentNode).removeClass('active');
			delete productResults[catSlug];
			updateProductResults();
		} else {
			$(e.target.parentNode).addClass('active');
			if (isNumeric(catId)) {
				fetchProducts(catId);
			}
		}
	})
});
